import React from "react";
import PropTypes from 'prop-types';
import { PageIntroGraphic } from "../Graphics/Block";
import CtaBtn from "../UIElements/CtaBtn";

const colourVariants = {
  text: {
    plum: 'text-plum-700',
    blue: 'text-blue-700',
    orange: 'text-orange-700',
    moon: 'text-moon-700',
  },
}

export default function MainPageIntro(
    {
        title,
        introText,
        chart,
        chartColour,
        accentColour,
        introImage,
        introGatsbyImage,
        introImageLogo,
        introImageFullSize,
        customGraphic,
        ctaLabel,
        ctaLink,
        ctaNewTab,
        tintOverlay,
        noMobileGraphic,
    }) {

    return (
        <div className="bg-white mb-14 lg:mb-32">
            <div className="max-full xl:mx-auto xl:max-w-7xl">
                <div className="flex flex-col-reverse md:flex-row gap-4">
                    <div className={`${noMobileGraphic ? 'hidden lg:block' : 'block'}`}>
                        {customGraphic ? 
                          <>{customGraphic}</>
                        : <PageIntroGraphic tint={accentColour} image={introImage} gatsbyImage={introGatsbyImage} imageLogo={introImageLogo} imageFullSize={introImageFullSize} chart={chart} chartColour={chartColour} tintOverlay={tintOverlay} /> }
                        
                    </div>
                    <div className="lg:mt-10 lg:mr-10 mx-auto">
                        <div className="max-w-xl mb-10 mr-10 lg:mr-0 ml-10">
                            <h2 className={`${colourVariants['text'][accentColour]} font-title leading-tight text-[30px] lg:text-[45px] font-semibold mb-[30px]`}>{title}</h2>
                            {/* {introText.map((b, idx) => {
                                return (
                                    <p key={idx} className={`${idx === 0 ? 'text-' + accentColour + '-900' : 'text-global-700 font-light'} tracking-wide font-content text-[15px] mb-[20px]`}>
                                        {b.Paragraph}
                                    </p>
                                )
                            })} */}
                            <div className={`${'main-page-text-' + accentColour} text-[15px] tracking-wide mb-10 blog-content`} dangerouslySetInnerHTML={{__html: introText}} />
                            {
                                ctaLabel && ctaLink ? 
                                    <CtaBtn colour={accentColour} label={ctaLabel} link={ctaLink} newTab={ctaNewTab} className="mt-2"/>
                            :   null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

MainPageIntro.propTypes = {
    title: PropTypes.string.isRequired,
    introText: PropTypes.string.isRequired,
    accentColour: PropTypes.string.isRequired,
    introImage: PropTypes.string,
    customGraphic: PropTypes.any,
    ctaLabel: PropTypes.string,
    ctaLink: PropTypes.string
}